import { render } from "./BackofficeLayout.vue?vue&type=template&id=2e951f02&ts=true"
import script from "./BackofficeLayout.vue?vue&type=script&lang=ts"
export * from "./BackofficeLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__